import { getISOLocale } from '~/utils/locale';

// Google Tag Manager Class to be injected
class GTM {
    constructor(ctx, options) {
        this.ctx = ctx;
        this.options = options;
    }

    init() {
        window[this.options.layer] = window[this.options.layer] || [];

        const eventGtmStart = {
            event: 'gtm.js',
            'gtm.start': new Date().getTime(),
        };

        const pageInitial = {
            [this.options.pageIdName]: `${this.ctx.app.router.options.base.replace(/\/$/, '') + this.ctx.route.path.replace(`/${this.ctx.app.i18n.locale}`, '').replace(/\/$/, '')}/`,
            [this.options.localeName]: getISOLocale(this.ctx.app.i18n.locale),
        };

        if (process.env.NODE_ENV !== 'production') {
            if (this.options.logTracking) {
                console.table(eventGtmStart);
                console.table(pageInitial);
            }
        } else {
            this._pushEvent(eventGtmStart);
            if (window.dataLayer) {
                window.dataLayer.push(pageInitial);
            }
        }

        if (this.options.pageTracking && (!this.options.respectDoNotTrack || !this.hasDNT())) {
            this.initPageTracking();
        }
    }

    initPageTracking() {
        this.ctx.app.router.afterEach((to, from) => {
            setTimeout(() => {
                // JM01 FORK:
                // - Adjust event params.
                // - Don't send event on first load
                // - Replace language part in URL
                // - dont track pageviewevent if we stay on same page
                if (from.name) {
                    if (from.path === to.path) return;

                    const page = to.gtm || {
                        event: this.options.pageViewEventName,
                        [this.options.pageIdName]: `${this.ctx.app.router.options.base.replace(/\/$/, '') + to.path.replace(`/${this.ctx.app.i18n.locale}`, '').replace(/\/$/, '')}/`,
                        [this.options.localeName]: getISOLocale(this.ctx.app.i18n.locale),
                    };

                    if (process.env.NODE_ENV !== 'production') {
                        if (this.options.logTracking) {
                            console.table(page);
                        }
                    } else {
                        window[this.options.layer].push(page);
                    }
                }
            }, 0);
        });
    }

    pushEvent(action, label, options) {
        const eventCategory = this.ctx.store.state.currentSeason === 'summer' ? 'Summer-Maps' : 'Winter-Maps';

        const event = {
            event: 'userinteraction',
            eventCategory,
            eventLabel: label,
            eventAction: action,
            eventNonInteraction: false,
            maps_region: this.ctx.store.state.currentResortId,
            ...options,
        };

        if (process.env.NODE_ENV !== 'production') {
            if (this.options.logTracking) {
                console.table(event);
            }
        } else {
            this._pushEvent(event);
        }
    }

    _pushEvent(obj) {
        try {
            if (!window || !window[this.options.layer]) {
                throw new Error('missing GTM dataLayer');
            }
            if (typeof obj !== 'object') {
                throw new TypeError('event should be an object');
            }
            if (!obj.hasOwnProperty('event')) {
                throw new Error('missing event property');
            }
            window[this.options.layer].push(obj);
        } catch (err) {
            console.error('[ERROR] [GTM]', err);
        }
    }

    hasDNT() {
        return window.doNotTrack === '1'
            || navigator.doNotTrack === 'yes'
            || navigator.doNotTrack === '1'
            || navigator.msDoNotTrack === '1'
            || (window.external && window.external.msTrackingProtectionEnabled && window.external.msTrackingProtectionEnabled());
    }
}

export default function (ctx, inject) {
    const options = {"id":"GTM-PTHPKN","pageViewEventName":"pageviewevent","pageIdName":"page_pageInfo_pageID","localeName":"page_pageInfo_language","pageTracking":true,"dev":true,"logTracking":false,"layer":"dataLayer","respectDoNotTrack":false,"query":{},"scriptURL":"//www.googletagmanager.com/gtm.js","noscriptURL":"//www.googletagmanager.com/ns.html","env":{}};

    // Create a new Auth instance
    const $gtm = new GTM(ctx, options);
    inject('gtm', $gtm);

    $gtm.init();
}
